import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.codex');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-codex',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.codex/view.scss */
:host {
  display: block;
  min-height: 100%;
  background: #f6f7f4;
  color: #17202a;
}

.page-wrap {
  max-width: 1360px;
  margin: 0 auto;
  padding: 34px 28px 56px;
}

.work-header,
.table-panel,
.modal-panel {
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 44px rgba(23, 32, 42, 0.06);
}

.work-header {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 24px;
  padding: 28px;
}

.header-copy h1 {
  margin: 6px 0 8px;
  color: #17202a;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 0;
}

.header-copy p {
  max-width: 720px;
  margin: 0;
  color: #657069;
  font-size: 15px;
  line-height: 1.65;
}

.eyebrow,
.section-kicker,
.metric-card .label,
.command-card .label {
  color: #b28921;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

.header-actions,
.modal-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

button {
  font: inherit;
}

.primary-btn,
.secondary-btn,
.table-btn,
.icon-btn,
.danger-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 8px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: background-color 0.16s ease, border-color 0.16s ease, color 0.16s ease, transform 0.16s ease;
  white-space: nowrap;
}

.primary-btn,
.secondary-btn,
.danger-btn {
  min-height: 42px;
  padding: 0 16px;
  font-weight: 750;
}

.primary-btn {
  border-color: #10375c;
  background: #10375c;
  color: #ffffff;
}

.primary-btn:hover {
  background: #0b2947;
}

.secondary-btn {
  border-color: #d8ded6;
  background: #ffffff;
  color: #27313d;
}

.secondary-btn:hover {
  border-color: #10375c;
  color: #10375c;
}

.danger-btn {
  border-color: #b42318;
  background: #b42318;
  color: #ffffff;
}

.danger-btn:hover {
  background: #8f1d14;
}

.primary-btn:disabled,
.secondary-btn:disabled,
.icon-btn:disabled,
.danger-btn:disabled,
.table-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.command-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  margin-top: 18px;
}

.command-card {
  display: grid;
  grid-template-columns: 54px 1fr auto;
  align-items: center;
  gap: 18px;
  width: 100%;
  min-height: 116px;
  padding: 20px;
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: #ffffff;
  color: inherit;
  text-align: left;
  box-shadow: 0 14px 34px rgba(23, 32, 42, 0.05);
  cursor: pointer;
  transition: border-color 0.16s ease, background-color 0.16s ease, transform 0.16s ease;
}

.command-card:hover {
  border-color: #b28921;
  transform: translateY(-1px);
}

.command-card.is-strong {
  border-color: #cda83c;
  background: #fffaf0;
}

.command-icon {
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  border-radius: 8px;
  background: #eef4f1;
  color: #0f6b57;
  font-size: 21px;
}

.command-card.is-strong .command-icon {
  background: #10375c;
  color: #ffffff;
}

.command-body {
  display: grid;
  gap: 5px;
  min-width: 0;
}

.command-body strong {
  color: #17202a;
  font-size: 18px;
  font-weight: 750;
}

.command-body small {
  color: #6a746f;
  font-size: 13px;
  line-height: 1.45;
}

.command-arrow {
  color: #9aa39c;
}

.metric-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
  margin-top: 18px;
}

.metric-card {
  min-height: 106px;
  padding: 18px;
  border: 1px solid #dfe3db;
  border-radius: 8px;
  background: #ffffff;
  color: inherit;
  text-align: left;
  cursor: pointer;
}

.metric-card strong {
  display: block;
  margin-top: 10px;
  color: #10375c;
  font-size: 27px;
  font-weight: 800;
  font-variant-numeric: tabular-nums;
}

.metric-card small {
  color: #717b75;
  font-size: 12px;
  font-weight: 700;
}

.metric-card:hover,
.metric-card.is-active {
  border-color: #0f766e;
  background: #ecfdf5;
}

.table-panel {
  margin-top: 18px;
  overflow: hidden;
}

.panel-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 22px 24px;
  border-bottom: 1px solid #e4e7e1;
}

.panel-title h2,
.modal-title h2 {
  margin: 4px 0 0;
  color: #17202a;
  font-size: 20px;
  font-weight: 800;
}

.panel-count {
  padding: 6px 10px;
  border-radius: 999px;
  background: #eef4f1;
  color: #0f6b57;
  font-size: 13px;
  font-weight: 750;
}

.table-wrap {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  min-width: 1080px;
  border-collapse: collapse;
}

.data-table th {
  padding: 13px 18px;
  background: #f2f4f1;
  color: #657069;
  font-size: 12px;
  font-weight: 800;
  text-align: left;
}

.data-table td {
  padding: 16px 18px;
  border-top: 1px solid #edf0eb;
  color: #26313d;
  vertical-align: middle;
}

.data-table tbody tr {
  cursor: pointer;
}

.data-table tbody tr:hover {
  background: #fbfcfa;
}

.title-cell {
  min-width: 300px;
}

.title-cell strong {
  display: block;
  color: #17202a;
  font-weight: 750;
  line-height: 1.45;
  word-break: keep-all;
}

.title-cell span,
.date-text,
.doc-count {
  display: block;
  margin-top: 4px;
  color: #88928c;
  font-size: 12px;
}

.source-pill,
.status-badge,
.chapter-count {
  display: inline-flex;
  align-items: center;
  min-height: 28px;
  padding: 0 10px;
  border-radius: 999px;
  background: #eef0ed;
  color: #626b66;
  font-size: 12px;
  font-weight: 750;
  white-space: nowrap;
}

.source-pill {
  background: #fff2d6;
  color: #94690c;
}

.status-badge.is-done {
  background: #e9f7ef;
  color: #14754e;
}

.status-badge.is-progress {
  background: #eaf2ff;
  color: #1c5d99;
}

.status-badge.is-error {
  background: #fff1f0;
  color: #b42318;
}

.chapter-count {
  background: #eef4f1;
  color: #0f6b57;
}

.stage-text {
  color: #10375c;
  font-weight: 750;
  white-space: nowrap;
}

.action-cell {
  width: 1%;
}

.table-btn {
  min-height: 34px;
  padding: 0 11px;
  border-color: #d8ded6;
  background: #ffffff;
  color: #2b3440;
  font-size: 13px;
  font-weight: 750;
}

.table-btn.primary {
  border-color: #10375c;
  background: #10375c;
  color: #ffffff;
}

.table-btn:hover {
  border-color: #10375c;
  color: #10375c;
}

.table-btn.primary:hover {
  background: #0b2947;
  color: #ffffff;
}

.table-btn.danger {
  border-color: #f0d3cf;
  background: #ffffff;
  color: #b42318;
}

.table-btn.danger:hover {
  border-color: #f2a7a0;
  background: #fff5f4;
  color: #9c1f14;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: 6px;
  padding: 18px 22px 22px;
  border-top: 1px solid #edf0eb;
}

.page-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 36px;
  height: 36px;
  border: 1px solid #d8ded6;
  border-radius: 8px;
  background: #ffffff;
  color: #4d5751;
  font-weight: 850;
  cursor: pointer;
}

.page-btn:hover {
  border-color: #10375c;
  color: #10375c;
}

.page-btn.is-active {
  border-color: #10375c;
  background: #10375c;
  color: #ffffff;
}

.page-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.loading-state,
.empty-state {
  min-height: 280px;
  display: grid;
  place-items: center;
  align-content: center;
  gap: 12px;
  padding: 36px;
  color: #717b75;
  text-align: center;
}

.empty-state i {
  color: #b7beb7;
  font-size: 34px;
}

.empty-state strong {
  color: #17202a;
  font-size: 18px;
  font-weight: 750;
}

.empty-state p {
  max-width: 520px;
  margin: 0;
  font-size: 14px;
  line-height: 1.55;
}

.spinner {
  width: 34px;
  height: 34px;
  border: 3px solid #dfe3db;
  border-top-color: #10375c;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: grid;
  place-items: center;
  padding: 24px;
  background: rgba(15, 22, 31, 0.42);
}

.modal-panel {
  width: min(620px, 100%);
  overflow: hidden;
}

.modal-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
  padding: 22px 24px;
  border-bottom: 1px solid #e4e7e1;
}

.icon-btn {
  width: 36px;
  height: 36px;
  border-color: #d8ded6;
  background: #ffffff;
  color: #657069;
}

.icon-btn:hover {
  border-color: #10375c;
  color: #10375c;
}

.form-grid {
  display: grid;
  gap: 14px;
  padding: 24px;
}

.field {
  display: grid;
  gap: 8px;
  color: #2c3642;
  font-size: 13px;
  font-weight: 750;
}

.field input {
  width: 100%;
  height: 44px;
  padding: 0 13px;
  border: 1px solid #d8ded6;
  border-radius: 8px;
  outline: none;
}

.field input:focus {
  border-color: #10375c;
}

.field small {
  color: #66716a;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.45;
}

.create-guide {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  min-height: 74px;
  padding: 14px;
  border: 1px solid #e4e7df;
  border-radius: 8px;
  background: #fbfcfa;
  color: #66716a;
}

.create-guide i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background: #eef7f3;
  color: #0f6b57;
}

.create-guide strong {
  display: block;
  color: #17202a;
  font-size: 13px;
  font-weight: 750;
}

.create-guide span {
  display: block;
  margin-top: 3px;
  color: #66716a;
  font-size: 12px;
  line-height: 1.45;
}

.error-box {
  display: flex;
  gap: 8px;
  margin: 0 24px 16px;
  padding: 12px;
  border: 1px solid #f1b5ad;
  border-radius: 8px;
  background: #fff4f2;
  color: #a0342b;
  font-size: 13px;
}

.modal-actions {
  justify-content: flex-end;
  padding: 18px 24px 24px;
}

@media (max-width: 980px) {
  .page-wrap {
    padding: 20px 14px 40px;
  }
  .work-header,
  .panel-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .header-actions {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .metric-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .command-grid {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 560px) {
  .header-actions,
  .metric-grid {
    grid-template-columns: 1fr;
  }
}
/* Proposal page matched compact layer */
:host {
  background: #fafafa;
  color: #18181b;
}

.page-wrap {
  max-width: 1400px;
  padding: 20px 24px 60px;
}

.work-header {
  align-items: flex-start;
  padding: 0 0 12px;
  margin-bottom: 16px;
  border: 0;
  border-bottom: 1px solid #e4e4e7;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}

.header-copy h1 {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
}

.header-copy p {
  max-width: none;
  font-size: 11.5px;
  line-height: 1.45;
  color: #71717a;
}

.eyebrow,
.section-kicker,
.metric-card .label,
.command-card .label {
  color: #0f766e;
  font-size: 11px;
  font-weight: 650;
  text-transform: none;
}

.primary-btn,
.secondary-btn,
.table-btn,
.icon-btn {
  min-height: 32px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  transition: 0.16s ease;
}

.primary-btn {
  background: #0f766e;
  border-color: #0f766e;
}

.primary-btn:hover {
  background: #0b5f59;
}

.secondary-btn {
  border-color: #e4e4e7;
  color: #52525b;
}

.secondary-btn:hover {
  border-color: #99f6e4;
  color: #0f766e;
  background: #ecfdf5;
}

.command-grid {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  margin-top: 0;
  margin-bottom: 12px;
}

.command-card {
  grid-template-columns: 34px 1fr auto;
  min-height: auto;
  gap: 10px;
  padding: 12px;
  border-color: #e4e4e7;
  box-shadow: none;
}

.command-card:hover {
  border-color: #99f6e4;
  transform: none;
  background: #fafafa;
}

.command-card.is-strong {
  border-color: #99f6e4;
  background: #ecfdf5;
}

.command-icon,
.command-card.is-strong .command-icon {
  width: 34px;
  height: 34px;
  border-radius: 6px;
  background: #f4f4f5;
  color: #0f766e;
  font-size: 14px;
}

.command-body {
  gap: 2px;
}

.command-body strong {
  color: #18181b;
  font-size: 12px;
  font-weight: 650;
}

.command-body small {
  font-size: 11.5px;
  color: #71717a;
}

.metric-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 0;
  margin-bottom: 12px;
}

.metric-card {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 28px;
  padding: 0 10px;
  border-color: #e4e4e7;
  border-radius: 999px;
  background: #f4f4f5;
}

.metric-card:hover,
.metric-card.is-active {
  border-color: #99f6e4;
  background: #ecfdf5;
  color: #0f766e;
}

.metric-card strong {
  display: inline;
  margin: 0;
  color: #52525b;
  font-size: 11px;
  font-weight: 700;
}

.metric-card small {
  display: none;
}

.table-panel,
.modal-panel {
  border-color: #e4e4e7;
  box-shadow: none;
}

.table-panel {
  margin-top: 12px;
}

.panel-head,
.modal-head {
  min-height: 48px;
  padding: 12px 14px;
  border-bottom-color: #f4f4f5;
}

.panel-title h2,
.modal-title h2 {
  margin: 2px 0 0;
  font-size: 14px;
  font-weight: 700;
}

.panel-count {
  padding: 4px 8px;
  background: #f4f4f5;
  color: #52525b;
  font-size: 11px;
  font-weight: 650;
}

.data-table {
  min-width: 1160px;
}

.data-table th {
  padding: 10px 14px;
  background: #fafafa;
  font-size: 11px;
  font-weight: 650;
}

.data-table td {
  padding: 12px 14px;
  font-size: 12px;
}

.title-cell {
  min-width: 310px;
}

.title-cell strong,
.stage-text {
  font-size: 12px;
  font-weight: 650;
}

.source-pill,
.status-badge,
.chapter-count,
.table-btn {
  min-height: 26px;
  font-size: 11.5px;
  font-weight: 600;
}

.status-badge.is-done,
.source-pill {
  background: #ecfdf5;
  color: #0f766e;
}

.table-btn.primary {
  background: #0f766e;
  border-color: #0f766e;
}

.table-btn.primary:hover {
  background: #0b5f59;
}

.pagination {
  padding: 12px 14px 14px;
}

.page-btn {
  min-width: 30px;
  height: 30px;
  border-color: #e4e4e7;
  border-radius: 6px;
  font-size: 11.5px;
  font-weight: 600;
}

.page-btn:hover {
  border-color: #99f6e4;
  color: #0f766e;
  background: #ecfdf5;
}

.page-btn.is-active {
  border-color: #0f766e;
  background: #0f766e;
}

.action-cell {
  width: auto;
  display: flex;
  gap: 8px;
}

.loading-state,
.empty-state {
  min-height: 220px;
  padding: 42px 20px;
}

.empty-state i {
  font-size: 26px;
}

.empty-state strong {
  font-size: 13px;
  font-weight: 650;
}

.codex-page {
  font-size: 12px;
}

.date-text,
.doc-count {
  font-size: 11.5px;
}

.modal-backdrop {
  background: rgba(24, 24, 27, 0.38);
  backdrop-filter: blur(2px);
}

.modal-panel {
  width: min(560px, 100vw - 32px);
  border-radius: 10px;
}

.modal-head {
  padding: 18px 20px 14px;
  background: #ffffff;
}

.modal-title .section-kicker {
  color: #71717a;
  font-size: 10.5px;
  font-weight: 600;
}

.modal-title h2 {
  font-size: 15px;
  font-weight: 650;
}

.form-grid {
  gap: 12px;
  padding: 18px 20px 16px;
}

.field {
  gap: 6px;
  color: #52525b;
  font-size: 11.5px;
  font-weight: 500;
}

.field input {
  height: 38px;
  border-color: #e4e4e7;
  border-radius: 7px;
  color: #18181b;
  font-size: 12px;
}

.field input:focus {
  border-color: #99f6e4;
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.08);
}

.field small {
  font-size: 11px;
  font-weight: 400;
}

.file-drop {
  display: grid;
  place-items: center;
  gap: 5px;
  min-height: 126px;
  padding: 22px;
  border: 1px dashed #d4d4d8;
  border-radius: 8px;
  background: #fafafa;
  color: #71717a;
  text-align: center;
  cursor: pointer;
}

.file-drop input {
  display: none;
}

.file-drop.create-drop {
  cursor: pointer;
}

.file-drop i {
  color: #0f766e;
  font-size: 22px;
}

.file-drop strong {
  color: #18181b;
  font-size: 12px;
  font-weight: 600;
}

.file-drop small {
  max-width: 420px;
  font-size: 11px;
  font-weight: 400;
  line-height: 1.45;
}

.file-drop em {
  color: #0f766e;
  font-size: 11px;
  font-style: normal;
  font-weight: 650;
}

.error-box {
  margin: 0 20px 16px;
}

.modal-actions {
  padding: 14px 20px 18px;
  border-top: 1px solid #f4f4f5;
}

.modal-actions .primary-btn,
.modal-actions .secondary-btn {
  min-height: 34px;
  font-weight: 600;
}

@media (max-width: 980px) {
  .work-header,
  .panel-head {
    align-items: flex-start;
    flex-direction: column;
  }
  .header-actions,
  .modal-actions {
    width: 100%;
    flex-wrap: wrap;
  }
  .primary-btn,
  .secondary-btn {
    flex: 1 1 180px;
  }
  .command-grid {
    grid-template-columns: 1fr;
  }
  .metric-grid {
    display: flex;
  }
  .page-wrap {
    padding: 20px 14px 40px;
  }
}
/* Codex-specific character layer */
.codex-page {
  --codex-navy: #0f3057;
  --codex-teal: #0f766e;
  --codex-sky: #dbeafe;
  --codex-amber: #b8871f;
}

.codex-page .header-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 4px;
}

.codex-page .mode-chip {
  display: inline-flex;
  align-items: center;
  min-height: 20px;
  padding: 0 7px;
  border: 1px solid var(--codex-sky);
  border-radius: 999px;
  background: #eff6ff;
  color: var(--codex-navy);
  font-size: 10.5px;
  font-weight: 650;
}

.codex-page .eyebrow,
.codex-page .section-kicker,
.codex-page .metric-card .label,
.codex-page .command-card .label {
  color: var(--codex-navy);
}

.codex-page .primary-btn,
.codex-page .table-btn.primary {
  background: var(--codex-navy);
  border-color: var(--codex-navy);
}

.codex-page .primary-btn:hover,
.codex-page .table-btn.primary:hover {
  background: #123b69;
}

.codex-page .command-card {
  position: relative;
  overflow: hidden;
}

.codex-page .command-card::before {
  content: "";
  position: absolute;
  inset: 10px auto 10px 0;
  width: 3px;
  border-radius: 0 999px 999px 0;
  background: #d4d4d8;
}

.codex-page .command-card.is-strong {
  border-color: #bfdbfe;
  background: #f8fbff;
}

.codex-page .command-card.is-strong::before {
  background: var(--codex-navy);
}

.codex-page .command-card:hover {
  border-color: #bfdbfe;
  background: #f8fbff;
}

.codex-page .command-card.is-strong .command-icon {
  background: var(--codex-navy);
  color: #ffffff;
}

.codex-page .command-icon {
  background: #ecfdf5;
  color: var(--codex-teal);
}

.codex-page .studio-flow {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 12px;
  padding: 9px 12px;
  border: 1px solid #e4e4e7;
  border-radius: 8px;
  background: #ffffff;
}

.codex-page .flow-item {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  color: #52525b;
  white-space: nowrap;
}

.codex-page .flow-index {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 6px;
  background: #f4f4f5;
  color: #71717a;
  font-size: 10px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.codex-page .flow-item b {
  font-size: 11.5px;
  font-weight: 650;
}

.codex-page .flow-line {
  flex: 1;
  height: 1px;
  min-width: 22px;
  background: #e4e4e7;
}

.codex-page .metric-card.is-active {
  border-color: #bfdbfe;
  background: #eff6ff;
  color: var(--codex-navy);
}

.codex-page .metric-card.is-active strong {
  color: var(--codex-navy);
}

.codex-page .stage-text {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: 7px;
}

.codex-page .stage-text::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 999px;
  background: var(--codex-teal);
  box-shadow: 0 0 0 3px rgba(15, 118, 110, 0.1);
}

.codex-page .chapter-count {
  background: #eff6ff;
  color: var(--codex-navy);
}

.codex-page .table-btn.danger {
  border-color: #f0d3cf;
  background: #ffffff;
  color: #b42318;
}

.codex-page .table-btn.danger:hover {
  border-color: #f2a7a0;
  background: #fff5f4;
  color: #9c1f14;
}

.codex-page .modal-panel {
  border-top: 3px solid var(--codex-navy);
}

.codex-page .codex-flow-card {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  padding: 10px;
  border: 1px solid #e4e7df;
  border-radius: 8px;
  background: #fafafa;
}

.codex-page .modal-flow-step {
  min-height: 58px;
  display: grid;
  align-content: center;
  gap: 5px;
  padding: 10px;
  border: 1px solid #eeeeef;
  border-radius: 7px;
  background: #ffffff;
}

.codex-page .modal-flow-step span {
  color: var(--codex-teal);
  font-size: 10.5px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.codex-page .modal-flow-step b {
  color: #18181b;
  font-size: 11.5px;
  font-weight: 650;
}

.codex-create-modal {
  --codex-navy: #0f3057;
  --codex-teal: #0f766e;
  width: min(760px, 100vw - 32px);
  border: 1px solid #dbe2ea;
  border-top: 0;
  border-radius: 12px;
  overflow: hidden;
}

.codex-create-modal .modal-head {
  min-height: 64px;
  padding: 16px 18px;
  border-bottom: 1px solid #edf1f5;
  background: #ffffff;
}

.codex-create-modal .modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.codex-create-modal .modal-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: var(--codex-navy);
  color: #ffffff;
  font-size: 15px;
}

.codex-create-modal .modal-title .section-kicker {
  color: var(--codex-teal);
  font-size: 10.5px;
  font-weight: 650;
}

.codex-create-modal .modal-title h2 {
  margin-top: 2px;
  color: #18181b;
  font-size: 16px;
  font-weight: 700;
}

.codex-create-modal .icon-btn {
  border-color: #e4e4e7;
  border-radius: 8px;
}

.create-modal-body {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  min-height: 268px;
}

.create-rail {
  position: relative;
  display: grid;
  align-content: start;
  gap: 14px;
  padding: 20px;
  border-right: 1px solid #edf1f5;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

.create-rail h3 {
  margin: -8px 0 0;
  color: #101827;
  font-size: 15px;
  font-weight: 700;
}

.rail-steps {
  display: grid;
  gap: 8px;
}

.rail-step {
  display: grid;
  grid-template-columns: 30px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
  min-height: 40px;
  padding: 7px 8px;
  border: 1px solid #e0e7ef;
  border-radius: 9px;
  background: rgba(255, 255, 255, 0.74);
}

.rail-step span {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 26px;
  border-radius: 7px;
  background: #eef6ff;
  color: var(--codex-navy);
  font-size: 10px;
  font-weight: 750;
  font-variant-numeric: tabular-nums;
}

.rail-step b {
  color: #344054;
  font-size: 12px;
  font-weight: 650;
}

.create-form {
  display: grid;
  align-content: start;
  gap: 14px;
  padding: 22px;
  background: #ffffff;
}

.create-form .field {
  font-size: 12px;
}

.create-form .field input {
  height: 42px;
  border-radius: 8px;
}

.create-file-list {
  display: grid;
  gap: 8px;
  padding: 10px;
  border: 1px solid #e4e4e7;
  border-radius: 10px;
  background: #fbfcfd;
}

.create-file-head,
.create-file-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.create-file-head {
  justify-content: space-between;
  padding-bottom: 8px;
  border-bottom: 1px solid #eef0f3;
}

.create-file-head strong {
  display: block;
  color: #18181b;
  font-size: 11.5px;
  font-weight: 650;
}

.create-file-head span {
  display: block;
  margin-top: 2px;
  color: #71717a;
  font-size: 10.5px;
}

.create-file-row {
  min-height: 42px;
  padding: 8px;
  border: 1px solid #eeeeef;
  border-radius: 8px;
  background: #ffffff;
}

.create-file-row.is-uploading {
  opacity: 0.7;
}

.create-file-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 30px;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  background: #eff6ff;
  color: var(--codex-navy);
}

.create-file-meta {
  display: grid;
  gap: 2px;
  min-width: 0;
  flex: 1;
}

.create-file-meta strong {
  overflow: hidden;
  color: #18181b;
  font-size: 11.5px;
  font-weight: 650;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.create-file-meta span {
  color: #71717a;
  font-size: 10.5px;
}

.clear-file-btn,
.remove-file-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: #71717a;
  cursor: pointer;
  font-size: 10.5px;
  font-weight: 650;
}

.clear-file-btn {
  min-height: 28px;
  padding: 0 8px;
}

.remove-file-btn {
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
}

.clear-file-btn:hover,
.remove-file-btn:hover {
  background: #f4f4f5;
  color: #b42318;
}

.clear-file-btn:disabled,
.remove-file-btn:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.create-summary {
  display: grid;
  grid-template-columns: 34px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  min-height: 70px;
  padding: 12px;
  border: 1px solid #e4e7df;
  border-radius: 10px;
  background: #fbfcfa;
}

.create-summary i {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 9px;
  background: #ecfdf5;
  color: var(--codex-teal);
}

.create-summary b {
  display: block;
  color: #18181b;
  font-size: 12px;
  font-weight: 650;
}

.create-summary span {
  display: block;
  margin-top: 3px;
  color: #71717a;
  font-size: 11px;
  line-height: 1.45;
}

.create-progress {
  display: grid;
  gap: 10px;
  padding: 12px;
  border: 1px solid #d8eee7;
  border-radius: 10px;
  background: #f4fbf8;
}

.create-progress-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
}

.create-progress-head div {
  min-width: 0;
}

.create-progress-head strong {
  display: block;
  color: #0f5f59;
  font-size: 12px;
  font-weight: 700;
}

.create-progress-head span {
  display: block;
  margin-top: 3px;
  color: #617069;
  font-size: 11px;
  line-height: 1.45;
}

.create-progress-head b {
  color: var(--codex-teal);
  font-size: 13px;
  font-weight: 750;
  white-space: nowrap;
}

.create-progress-track {
  position: relative;
  overflow: hidden;
  height: 8px;
  border-radius: 999px;
  background: #dce7e2;
}

.create-progress-fill {
  position: absolute;
  inset: 0 auto 0 0;
  min-width: 10px;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--codex-teal), #16a085);
  transition: width 0.22s ease;
}

.create-progress-fill.is-processing::after {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.55), transparent);
  animation: create-progress-shine 1.15s linear infinite;
}

.create-progress-steps {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 6px;
}

.create-step {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  min-width: 0;
  min-height: 28px;
  padding: 0 8px;
  border: 1px solid #e2e8e5;
  border-radius: 7px;
  background: #ffffff;
  color: #7c8882;
  font-size: 11px;
  font-weight: 650;
}

.create-step i {
  font-size: 10px;
}

.create-step.is-active,
.create-step.is-done {
  border-color: #99f6e4;
  background: #ecfdf5;
  color: var(--codex-teal);
}

@keyframes create-progress-shine {
  from {
    transform: translateX(-100%);
  }
  to {
    transform: translateX(100%);
  }
}
.codex-create-modal .error-box {
  margin: 0 22px 16px 302px;
}

.codex-create-modal .modal-actions {
  padding: 14px 18px 18px;
  border-top: 1px solid #edf1f5;
  background: #ffffff;
}

.codex-delete-modal {
  --codex-navy: #0f3057;
  width: min(520px, 100vw - 32px);
  border: 1px solid #dbe2ea;
  border-top: 3px solid #b42318;
  border-radius: 12px;
  overflow: hidden;
}

.codex-delete-modal .modal-head {
  min-height: 64px;
  padding: 16px 18px;
  border-bottom: 1px solid #edf1f5;
  background: #ffffff;
}

.codex-delete-modal .modal-title-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.codex-delete-modal .modal-mark.danger {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 38px;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: #fff1f0;
  color: #b42318;
}

.codex-delete-modal .modal-title .section-kicker {
  color: var(--codex-navy);
  font-size: 10.5px;
  font-weight: 650;
}

.codex-delete-modal .modal-title h2 {
  margin-top: 2px;
  color: #18181b;
  font-size: 16px;
  font-weight: 700;
}

.delete-modal-body {
  display: grid;
  gap: 7px;
  padding: 22px;
  background: #ffffff;
}

.delete-modal-body strong {
  color: #18181b;
  font-size: 15px;
  font-weight: 700;
}

.delete-modal-body span {
  color: #71717a;
  font-size: 12px;
}

.delete-modal-body p {
  margin: 8px 0 0;
  padding: 12px;
  border: 1px solid #f0d3cf;
  border-radius: 8px;
  background: #fff8f7;
  color: #7a271a;
  font-size: 12px;
  line-height: 1.55;
}

.codex-delete-modal .error-box {
  margin: 0 22px 16px;
}

.codex-delete-modal .modal-actions {
  padding: 14px 18px 18px;
  border-top: 1px solid #edf1f5;
  background: #ffffff;
}

@media (max-width: 720px) {
  .codex-page .studio-flow {
    align-items: flex-start;
    flex-direction: column;
  }
  .codex-page .flow-line {
    display: none;
  }
  .codex-page .codex-flow-card {
    grid-template-columns: 1fr;
  }
  .create-modal-body {
    grid-template-columns: 1fr;
  }
  .create-rail {
    border-right: 0;
    border-bottom: 1px solid #edf1f5;
  }
  .codex-create-modal .error-box {
    margin: 0 18px 16px;
  }
}`],
})
export class PageCodexComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public loading: boolean = true;
    public items: any[] = [];
    public summary: any = { total: 0, active: 0, design_ready: 0, toc_ready: 0 };
    public filter: string = 'all';
    public page: number = 1;
    public pageSize: number = 10;
    public showCreateModal: boolean = false;
    public createTitle: string = '';
    public createFiles: File[] = [];
    public createError: string = '';
    public creating: boolean = false;
    public createProgress: any = this.getInitialCreateProgress();
    private createProgressTimer: any = null;
    public deleteTarget: any = null;
    public deleteError: string = '';
    public deletingNoticeNo: string = '';

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        try {
            const res = await wiz.call('list');
            if (res.code === 200) {
                this.items = res.data.rows || [];
                this.summary = res.data.summary || this.summary;
                this.clampPage();
            }
        } catch { }
        this.loading = false;
        await this.service.render();
    }

    public async openCreate() {
        this.showCreateModal = true;
        this.createTitle = '';
        this.createFiles = [];
        this.createError = '';
        this.resetCreateProgress();
        await this.service.render();
    }

    public async closeCreate() {
        if (this.creating) return;
        this.showCreateModal = false;
        this.createFiles = [];
        this.createError = '';
        this.resetCreateProgress();
        await this.service.render();
    }

    public async onCreateFileChange(event: any) {
        if (this.creating) return;
        const selected = Array.from(event?.target?.files || []) as File[];
        this.createFiles = [...this.createFiles, ...selected];
        this.createError = '';
        if (event?.target) event.target.value = '';
        await this.service.render();
    }

    public async removeCreateFile(index: number) {
        if (this.creating) return;
        this.createFiles = this.createFiles.filter((_, i) => i !== index);
        this.createError = '';
        await this.service.render();
    }

    public async clearCreateFiles() {
        if (this.creating) return;
        this.createFiles = [];
        this.createError = '';
        await this.service.render();
    }

    public async submitCreate() {
        const title = (this.createTitle || '').trim();
        if (!title || this.creating) return;

        this.creating = true;
        this.createError = '';
        this.setCreateProgress({
            percent: 1,
            phase: '자료함 생성 준비 중',
            detail: this.createFiles.length > 0
                ? `${this.createFiles.length}개 RFP 파일을 전송할 준비를 하고 있습니다.`
                : '새 Codex 자료함 정보를 준비하고 있습니다.',
            step: 'prepare'
        });
        await this.service.render();

        try {
            const formData = new FormData();
            formData.append('title', title);
            for (const file of this.createFiles) formData.append('file', file);

            const createResult = await this.createWorkspaceWithProgress(formData);
            const result = createResult.result;
            const rawText = createResult.rawText || '';
            const responseStatus = createResult.status || 0;

            if (result?.code === 200 && result.data?.notice_no) {
                this.setCreateProgress({
                    percent: 100,
                    phase: '완료',
                    detail: this.createFiles.length > 0
                        ? 'RFP 등록이 완료되었습니다. Codex 자료함으로 이동합니다.'
                        : '자료함 생성이 완료되었습니다. Codex 자료함으로 이동합니다.',
                    step: 'done'
                });
                await this.service.render();
                this.showCreateModal = false;
                this.creating = false;
                this.service.href(`/codex/${encodeURIComponent(result.data.notice_no)}`);
                return;
            }
            this.createError = result?.data?.message || result?.message || this.extractErrorMessage(rawText) || `자료함을 만들지 못했습니다. (${responseStatus})`;
        } catch (e: any) {
            this.createError = e?.message || '자료함을 만들지 못했습니다.';
        }

        this.stopCreateProgressTimer();
        this.creating = false;
        this.setCreateProgress({
            percent: 0,
            phase: '생성 실패',
            detail: '',
            step: 'error'
        });
        await this.service.render();
    }

    private getInitialCreateProgress() {
        return {
            percent: 0,
            phase: '대기 중',
            detail: '',
            step: 'idle'
        };
    }

    private resetCreateProgress() {
        this.stopCreateProgressTimer();
        this.createProgress = this.getInitialCreateProgress();
    }

    private setCreateProgress(progress: any) {
        this.createProgress = {
            ...this.createProgress,
            ...progress,
            percent: Math.max(0, Math.min(100, Math.round(progress?.percent ?? this.createProgress.percent ?? 0)))
        };
    }

    private stopCreateProgressTimer() {
        if (this.createProgressTimer) {
            clearInterval(this.createProgressTimer);
            this.createProgressTimer = null;
        }
    }

    private startCreateServerProgress() {
        this.stopCreateProgressTimer();
        const hasFiles = this.createFiles.length > 0;
        this.setCreateProgress({
            percent: Math.max(this.createProgress.percent || 0, hasFiles ? 72 : 45),
            phase: hasFiles ? 'RFP 텍스트 추출 중' : '자료함 생성 중',
            detail: hasFiles
                ? '업로드한 RFP 파일을 저장하고 본문 텍스트를 추출하고 있습니다.'
                : '자료함 상태와 Codex 작업공간을 생성하고 있습니다.',
            step: hasFiles ? 'parse' : 'create'
        });
        this.createProgressTimer = setInterval(() => {
            if (!this.creating) {
                this.stopCreateProgressTimer();
                return;
            }
            const current = this.createProgress.percent || (hasFiles ? 72 : 45);
            const increment = current < 84 ? 3 : current < 92 ? 2 : 1;
            this.setCreateProgress({
                percent: Math.min(94, current + increment),
                phase: hasFiles ? 'RFP 텍스트 추출 중' : '자료함 생성 중',
                detail: hasFiles
                    ? '서버에서 문서 페이지와 본문 텍스트를 추출하고 있습니다.'
                    : 'Codex Studio에서 사용할 초기 상태를 저장하고 있습니다.',
                step: hasFiles ? 'parse' : 'create'
            });
            this.service.render();
        }, 1100);
    }

    private createWorkspaceWithProgress(formData: FormData): Promise<any> {
        return new Promise((resolve, reject) => {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', wiz.url('create_workspace'), true);
            xhr.withCredentials = true;

            xhr.upload.onprogress = (event: ProgressEvent) => {
                if (event.lengthComputable) {
                    const transferRatio = event.total > 0 ? event.loaded / event.total : 0;
                    const percent = Math.max(3, Math.min(70, Math.round(transferRatio * 70)));
                    this.setCreateProgress({
                        percent,
                        phase: this.createFiles.length > 0 ? 'RFP 파일 전송 중' : '자료함 요청 전송 중',
                        detail: `${this.formatFileSize(event.loaded)} / ${this.formatFileSize(event.total)} 전송`,
                        step: 'upload'
                    });
                } else {
                    this.setCreateProgress({
                        percent: Math.max(this.createProgress.percent || 0, 8),
                        phase: this.createFiles.length > 0 ? 'RFP 파일 전송 중' : '자료함 요청 전송 중',
                        detail: '요청을 서버로 보내고 있습니다.',
                        step: 'upload'
                    });
                }
                this.service.render();
            };

            xhr.upload.onload = () => {
                this.startCreateServerProgress();
                this.service.render();
            };

            xhr.onreadystatechange = () => {
                if (xhr.readyState !== 4) return;
                this.stopCreateProgressTimer();
                const rawText = xhr.responseText || '';
                let result = null;
                try {
                    result = rawText ? JSON.parse(rawText) : null;
                } catch {
                    result = null;
                }
                resolve({
                    status: xhr.status,
                    rawText,
                    result
                });
            };

            xhr.onerror = () => {
                this.stopCreateProgressTimer();
                reject(new Error('네트워크 오류로 자료함 생성이 중단되었습니다.'));
            };
            xhr.onabort = () => {
                this.stopCreateProgressTimer();
                reject(new Error('자료함 생성 요청이 취소되었습니다.'));
            };

            xhr.send(formData);
        });
    }

    private extractErrorMessage(rawText: string): string {
        if (!rawText) return '';
        return rawText
            .replace(/<style[\s\S]*?<\/style>/gi, ' ')
            .replace(/<script[\s\S]*?<\/script>/gi, ' ')
            .replace(/<[^>]+>/g, ' ')
            .replace(/\s+/g, ' ')
            .trim()
            .slice(0, 240);
    }

    public async openDelete(item: any, event?: Event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        if (!item?.notice_no || this.deletingNoticeNo) return;
        this.deleteTarget = item;
        this.deleteError = '';
        await this.service.render();
    }

    public async closeDelete() {
        if (this.deletingNoticeNo) return;
        this.deleteTarget = null;
        this.deleteError = '';
        await this.service.render();
    }

    public async confirmDelete() {
        const item = this.deleteTarget;
        if (!item?.notice_no || this.deletingNoticeNo) return;

        this.deletingNoticeNo = item.notice_no;
        this.deleteError = '';
        await this.service.render();

        try {
            const res = await wiz.call('delete_workspace', { notice_no: item.notice_no });
            if (res.code === 200 || res.code === 404) {
                this.items = this.items.filter((row: any) => row.notice_no !== item.notice_no);
                this.deleteTarget = null;
                this.deletingNoticeNo = '';
                await this.load();
                return;
            }
            this.deleteError = res.data?.message || '자료함을 삭제하지 못했습니다.';
        } catch (e: any) {
            this.deleteError = e?.message || '자료함을 삭제하지 못했습니다.';
        }

        this.deletingNoticeNo = '';
        await this.service.render();
    }

    public async setFilter(filter: string) {
        this.filter = filter;
        this.page = 1;
        await this.service.render();
    }

    public get filteredItems(): any[] {
        if (this.filter === 'active') return this.items.filter((item: any) => (item.codex_running_count || 0) > 0);
        if (this.filter === 'rfp') return this.items.filter((item: any) => item.rfp_status === 'done' || item.rfp_status === 'partial');
        if (this.filter === 'design') return this.items.filter((item: any) => item.design_status === 'done' || item.design_status === 'approved');
        if (this.filter === 'toc') return this.items.filter((item: any) => item.toc_status === 'done' || item.toc_status === 'approved');
        return this.items;
    }

    public get pagedItems(): any[] {
        const start = (this.page - 1) * this.pageSize;
        return this.filteredItems.slice(start, start + this.pageSize);
    }

    public get totalPages(): number {
        return Math.ceil(this.filteredItems.length / this.pageSize) || 1;
    }

    public get pageStart(): number {
        if (this.filteredItems.length === 0) return 0;
        return (this.page - 1) * this.pageSize + 1;
    }

    public get pageEnd(): number {
        return Math.min(this.page * this.pageSize, this.filteredItems.length);
    }

    public get pageRange(): number[] {
        let pages: number[] = [];
        let start = Math.max(1, this.page - 2);
        let end = Math.min(this.totalPages, start + 4);
        start = Math.max(1, end - 4);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    public async goPage(p: number) {
        if (p < 1 || p > this.totalPages) return;
        this.page = p;
        await this.service.render();
    }

    private clampPage() {
        this.page = Math.min(Math.max(this.page, 1), this.totalPages);
    }

    public get rfpReadyCount(): number {
        return this.items.filter((item: any) => item.rfp_status === 'done' || item.rfp_status === 'partial').length;
    }

    public openStudio(item: any) {
        if (!item?.notice_no) return;
        this.service.href(`/codex/${encodeURIComponent(item.notice_no)}`);
    }

    public getStageLabel(item: any): string {
        return item?.studio_progress || '자료 준비';
    }

    public getSourceLabel(item: any): string {
        if (item?.source === 'codex_workspace') return '자료함';
        if (item?.source === 'codex_upload') return '기존 Codex RFP';
        return 'Codex';
    }

    public getRfpStatusLabel(item: any): string {
        if (item?.rfp_status === 'done') return '등록 완료';
        if (item?.rfp_status === 'partial') return '일부 등록';
        if (item?.rfp_status === 'pending') return '처리 중';
        return '미등록';
    }

    public getStatusClass(status: string): string {
        if (status === 'done' || status === 'approved') return 'is-done';
        if (status === 'running' || status === 'queued') return 'is-progress';
        if (status === 'error' || status === 'cancelled') return 'is-error';
        return '';
    }

    public formatDate(value: string): string {
        if (!value) return '-';
        return String(value).replace('T', ' ').slice(0, 16);
    }

    public getFileExtension(name: string = ''): string {
        const ext = (name.split('.').pop() || '').trim().toUpperCase();
        return ext && ext !== name.toUpperCase() ? ext : 'FILE';
    }

    public formatFileSize(size: number = 0): string {
        if (!Number.isFinite(size) || size <= 0) return '0 B';
        const units = ['B', 'KB', 'MB', 'GB'];
        let value = size;
        let unitIndex = 0;
        while (value >= 1024 && unitIndex < units.length - 1) {
            value = value / 1024;
            unitIndex += 1;
        }
        const digits = unitIndex === 0 || value >= 10 ? 0 : 1;
        return `${value.toFixed(digits)} ${units[unitIndex]}`;
    }

    public getCreateTotalSize(): string {
        return this.formatFileSize(this.createFiles.reduce((sum, file) => sum + (file.size || 0), 0));
    }
}

export default PageCodexComponent;